import React from 'react'

const CheckMarkIcon = props => (
  <svg x="0px" y="0px" viewBox="0 0 1000 1000" xmlSpace="preserve" {...props}>
    <path
      fill="currentColor"
      d="M662.7 333.3L447.3 566.2 313.6 465.9 257.6 540.5 461 696.3 732.4 398.5z"
    />
  </svg>
)

export default CheckMarkIcon
